import React, { Component, PropTypes } from 'react'
import BarSubscriptionDialog from './bar-subscription-dialog'
import { lang } from '../../strings'
import Tooltip from '../tooltip'

export default class BarSubscription extends Component {
  constructor(props) {
    super(props)

    this.state = this.makeInitialState(props)
  }

  makeInitialState(props) {
    return {
      showDialog: false,
      currentBarService: null,
    }
  }

  render() {
    let { showDialog, currentBarService } = this.state
    let { services } = this.props

    return (
      <div className='mp-tile'>
        <h2 className='h5 color-dark-blue'>{lang.barring.title}</h2>
        <table className='mp-table'>
          <tbody>
            {services.map(service => {
              let id = 'service' + service.id
              return (
                <tr key={service.id}>
                  <td>
                    {service.description}{' '}
                    {service.disabled ? (
                      <Tooltip tip={this.setTooltip(service.subType)} />
                    ) : null}
                  </td>
                  <td>
                    <div
                      style={{ float: 'right' }}
                      className={service.disabled ? 'mp-disabled' : ''}
                    >
                      <input
                        id={id}
                        className='mp-toggle mp-toggle-light'
                        type='checkbox'
                        checked={service.enabled}
                        disabled={service.disabled}
                        onChange={ev => this.confirmBarService(ev, service)}
                      />
                      <label htmlFor={id} className='mp-toggle-btn' />
                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
        {showDialog ? (
          <BarSubscriptionDialog
            barService={currentBarService}
            onConfirm={this.changeBarService}
            onClose={this.hideDialog}
          />
        ) : null}
      </div>
    )
  }

  setTooltip(subType) {
    switch (subType) {
      case 3:
        return lang.barring.tooltips.barSubscription
      case 9:
        return lang.barring.tooltips.barData
      default:
        return null
    }
  }

  changeBarService = ev => {
    ev.preventDefault()
    let service = this.state.currentBarService
    service.enabled = !service.enabled
    this.props.changeBarService(service)
    this.setState({ showDialog: false })
  }

  confirmBarService = (ev, service) => {
    ev.preventDefault()
    this.setState({
      currentBarService: service,
      showDialog: true,
    })
  }

  hideDialog = ev => {
    ev.preventDefault()
    this.setState({ showDialog: false })
  }
}

BarSubscription.propTypes = {
  services: PropTypes.array.isRequired,
  changeBarService: PropTypes.func.isRequired,
}
